import { useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const t = await getToken();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    return inst;
  }, [getToken]);
}

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.reason === "membership_required") return "Members only";
  if (d?.reason === "ticket_required") return "Ticket required";
  return fallback;
};

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const mediaUrl = async (api, id) => {
  const { data } = await api.get(`/media/${id}/url`);
  return `${BACKEND}${data.url}`;
};

// .catch handler for page loads: tell the user instead of failing silently.
export const loadFailed = (what) => (e) => toast.error(errMsg(e, `Couldn't load ${what}`));
